import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Constants from 'root/constants';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Emoji from 'view/emoji';
import View_Message_Editor from 'view/portal/message_editor';

var Portal_Comment = View.extend({
    pending_xhr: [],

    events: {
        'click .expand'                   : 'onExpandImage',
        'click .show-replies'             : 'onToggleReplies',
        'click .reply'                    : 'onReply',
        'click .edit'                     : 'onEdit',
        'click .delete'                   : 'onDelete',
        'click .like'                     : 'onLike',
        'click .reaction-add'             : 'onLike',
        'click .reaction'                 : 'onReactionVote',
        'click .attachment-preview video' : 'onPlayVideo'
    },

    dom_handlers: {
        onToggleReplies: function(e) {
            e.preventDefault();
            this.toggleReplies();
        },

        onExpandImage: function(e) {
            e.stopPropagation(); // fix nested child view event propagation
            this.$el.find('.attachment-preview img:first').toggleClass('expanded');
        },

        onReply: function(e) {
            e.preventDefault();
            e.stopPropagation(); // fix nested child view event propagation

            this.toggleReplies(true);
            this.$el.find('.region-reply-comment-new').show();

            if (!(this.views.reply_comment_new instanceof View_Message_Editor)) {
                var reply_to_name = this.model.getDisplayInfo().name;

                this.views.reply_comment_new = new View_Message_Editor({
                    model         : this.model,
                    embed         : this.embed,
                    has_submit    : true,
                    public_toggle : Cache.real_user_id ? true : false,
                    attachment    : true,
                    submit_text   : 'Reply',
                    placeholder   : reply_to_name ? 'Reply to ' + reply_to_name + ':' : 'Reply:',
                    show_tools    : true
                });
                this.views.reply_comment_new.render().$el.appendTo(this.$el.find('.region-message-editor'));
                this.views.reply_comment_new.on('submit', this.event_handlers.onReplyCommentSubmit.bind(this));
                this.views.reply_comment_new.on('close',  this.event_handlers.onReplyCommentClose.bind(this));
            }

            this.views.reply_comment_new.focus();
        },

        onLike: function(e) {
            e.preventDefault();
            e.stopPropagation(); // fix nested child view event propagation

            if (!(this.views.emoji instanceof View_Emoji)) {
                this.views.emoji = new View_Emoji({
                    onSelect: function(emoji) {
                        this.voteReaction(emoji),
                        this.views.emoji.hide();
                    }.bind(this),
                    launcher: this.$el.find('.like:first')
                });
                this.views.emoji.render().$el.hide().appendTo(this.$el.find('.region-emoji:first'));
                this.views.emoji.load();
            }

            this.views.emoji.toggle();

            if ($(e.currentTarget).hasClass('reaction-add')) {
                this.views.emoji.$el.css({
                    'left': Math.max(0, $(e.currentTarget).position().left - this.$el.find('.region-reactions').position().left  - this.views.emoji.$el.width() / 2),
                    'margin-bottom': 48
                });
            } else {
                this.views.emoji.$el.css({
                    'left': '',
                    'margin-bottom': ''
                });
            }
        },

        onEdit: function(e) {
            e.preventDefault();
            e.stopPropagation(); // fix nested child view event propagation

            Modals.editComment(this.model);
        },

        onDelete: function(e) {
            e.preventDefault();
            e.stopPropagation(); // fix nested child view event propagation

            Modals.deleteThread(this.model);
        },

        onReactionVote: function(e) {
            e.stopPropagation(); // fix nested child view event propagation

            if (!this.canComment()) {
                return;
            }

            var emoji = $(e.currentTarget).find('.emoji').text();
            this.voteReaction(emoji);
        },

        onPlayVideo: function(e) {
            e.stopPropagation(); // fix nested child view event propagation

            Modals.previewVideo($(e.currentTarget).attr('src'));
        }
    },

    event_handlers: {
        onCommentAdd: function(model) {
            if (this.is_child) {
                return;
            }

            if (model.get('reply_comment_id') !== this.model.id) {
                return;
            }

            this.views.reply_comments['_' + model.id] = new Portal_Comment({
                model: model,
                is_child: true
            });
            this.views.reply_comments['_' + model.id].render().$el.appendTo(this.$el.find('.region-replies'));


            this.$el.find('.show-replies .count').text(_.size(this.views.reply_comments) + ' ' + (_.size(this.views.reply_comments) === 1 ? 'reply' : 'replies'));
            this.$el.find('.show-replies').toggle(_.size(this.views.reply_comments) > 0);
        },

        onCommentRemove: function(model) {
            if (typeof this.views.reply_comments['_' + model.id] === 'undefined') {
                return;
            }

            this.views.reply_comments['_' + model.id].remove();
            delete this.views.reply_comments['_' + model.id];

            this.$el.find('.show-replies .count').text(_.size(this.views.reply_comments) + ' ' + (_.size(this.views.reply_comments) === 1 ? 'reply' : 'replies'));
            this.$el.find('.show-replies').toggle(_.size(this.views.reply_comments) > 0);
        },

        onReplyCommentClose: function() {
            this.$el.find('.region-reply-comment-new').hide();
        },

        onReplyCommentSubmit: function(message_data) {
            if (!message_data.comment) {
                return;
            }

            if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
                Modals.portalGuest();
                return;
            }

            this.views.reply_comment_new.disable();

            var xhr = Cache.app.request({
                action: 'feedback\\Comment/add',
                data: {
                    id                      : this.model.get('feedback_id'),
                    reply_comment_id        : this.model.id,
                    is_public               : message_data.is_public,
                    comment                 : message_data.comment,
                    attachment_file_name    : message_data.attachment.file_name,
                    attachment_file_content : message_data.attachment.file_content
                },
                complete: () => {
                    var index = this.pending_xhr.indexOf(xhr);

                    if (index !== -1) {
                        this.pending_xhr.splice(index, 1);
                    }

                    if (this.views.reply_comment_new.enable) {
                        this.views.reply_comment_new.enable();
                    }
                },
                success: (data) => {
                    Cache.feedback_comment.add(data);

                    this.views.reply_comment_new.setText('', true);
                    UI.success('Comment added');
                }
            });

            this.pending_xhr.push(xhr);
        }
    },

    initialize: function(options) {
        this.embed = options.embed

        this.views = {
            reply_comments: {},
            reply_comment_new: {},
            emoji: {}
        };

        this.is_child = !!options.is_child;

        if (!this.is_child) {
            Cache.feedback_comment.where({reply_comment_id: this.model.id}).forEach(function(model) {
                this.views.reply_comments['_' + model.id] = new Portal_Comment({
                    model: model,
                    is_child: true
                });
            }.bind(this));
        }

        if (this.is_child) {
            this.$el.addClass('portal-reply-comment');
        } else {
            this.$el.addClass('portal-thread');
        }

        this.listenTo(Cache.feedback_comment, 'add',    this.event_handlers.onCommentAdd);
        this.listenTo(Cache.feedback_comment, 'remove', this.event_handlers.onCommentRemove);

        this.listenTo(this.model, 'change:comment', this.renderMsg);

        this.on('remove', () => {
            if (this.pending_xhr.length) {
                this.pending_xhr.forEach((xhr) => {
                    xhr.abort();
                });

                this.pending_xhr = [];
            }
        });
    },

    voteReaction: function(emoji) {
        if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
            return;
        }

        Cache.app.request({
            action: 'feedback\\Comment/reaction',
            data: {
                id: this.model.id,
                emoji: '0x' + emoji.codePointAt(0).toString(16)
            },
            context: this,
            success: function(response) {
                this.model.set('reaction', response.reaction);
                this.renderReactions();
            }
        });
    },

    canComment: function() {
        var feedback_model = Cache.feedback.get(this.model.get('feedback_id'));

        if (Cache.real_user_id || Cache.portal_user) {
            return true;
        } else if (Cache.guest_user) {
            if (feedback_model && feedback_model.get('allow_public_comment')) {
                return true;
            }
        }

        return false;
    },

    renderReactions: function() {
        var reactions = this.model.get('reaction');

        if (reactions) {
            try {
                reactions = JSON.parse(reactions);
            } catch(e) {
            }

            var html = '';

            reactions.forEach(function(reaction) {
                html += '<span class="reaction">' +
                            '<span class="emoji">' + String.fromCodePoint(reaction.emoji) + '</span>' +
                            '<span class="count">' + reaction.count + '</span>' +
                        '</span>';
            });

            if (html && this.canComment()) {
                html += '<button type="button" class="reaction-add"></button>';
            }

            this.$el.find('.region-reactions:first').html(html);
        } else {
            this.$el.find('.region-reactions:first').html('');
        }
    },

    getVideoNoteTime: function() {
        var seconds = Math.round(this.model.get('video_time'));

        var hour = Math.floor(seconds / 3600);
        var min  = Math.floor((seconds - hour * 3600) / 60);
        var sec  = seconds - hour * 3600 - min * 60;

        if (min < 10) {
            min = '0' + min;
        }

        if (sec < 10) {
            sec = '0' + sec;
        }

        return (hour ? hour + ':' : '') + min + ':' + sec;
    },

    toggleReplies: function(show) {
        if (show === true) {
            this.$el.find('.replies').addClass('active');
        } else if (show === false) {
            this.$el.find('.replies').removeClass('active');
        } else {
            this.$el.find('.replies').toggleClass('active');
        }

    },

    showReplies: function() {
        this.toggleReplies(true);
        this.$el.find('.reply').click();
    },

    isAdmin: function() {
        var user_id = this.model.get('user_id');

        if (user_id) {
            var workspace_member = Cache.workspace_member.findWhere({user_id: user_id});

            if (workspace_member && (workspace_member.get('role') === Constants.ADMIN || workspace_member.get('role') === Constants.ASSIGNEE)) {
                return true;
            }
        }

        return false;
    },

    renderMsg: function() {
        var content =
        '<div class="comment">' + Util.parseComment(Util.urlify(Util.nl2br(this.model.escape('comment')))) + '</div>' +
        (this.model.get('last_edit_time') ?
        '<div class="edited">' +
            '<span class="tooltip" data-title="' + Util.moment(this.model.get('last_edit_time')) + '">(edited)</span>' +
        '</div>': '');

        this.$el.find('.msg').html(content);
    },

    render: function() {
        var content =
        '<div>' +
            (this.model.get('screen_number') ?
            '<div class="pin-num">' + this.model.get('screen_number') + '</div>' :
            '<div class="user-img-32" style="background-image:url(\'' + this.model.getAvatar() + '\');"></div>') +
        '</div>' +
        '<div>' +
            '<div class="author-name">' +
                this.model.getDisplayName(false, true, false) +
                (this.model.get('video_time') ? '<span class="video-note-time"><i class="fas fa-play-circle"></i>' + this.getVideoNoteTime() + '</span>' : '') +

                (this.isAdmin() ?
                '<span class="badge-small badge-primary-invert">Admin</span>' : '') +
            '</div>' +

            '<div class="msg"></div>' +

            (this.model.get('attachment') ?
            '<div class="attachment">' +
                '<div class="attachment-download">' +
                    '<a href="' + this.model.get('attachment') + '" target="download">' +
                        '<i class="far fa-paperclip margin-right-4"></i>' +
                        Util.baseName(this.model.get('attachment')) +
                    '</a>' +
                '</div>' +

                (Util.isImage(this.model.get('attachment')) ?
                '<div class="attachment-preview">' +
                    '<img src="' + this.model.escape('attachment') + '">' +
                    '<div class="expand"></div>' +
                '</div>' : '') +

                (Util.isVideo(this.model.get('attachment')) ?
                '<div class="attachment-preview attachment-preview-video">' +
                    '<video src="' + this.model.escape('attachment') + '" muted></video>' +
                '</div>' : '') +
            '</div>' : '') +

            '<div class="region-reactions"></div>' +

            '<div class="actions">' +
                '<div class="region-emoji"></div>' +

                '<span>' + Util.moment(this.model.get('time')) + '</span>' +

                (this.canComment() ?
                '<span><a class="like" href="#"><i class="far fa-smile"></i></a></span>' : '') +

                (this.is_child || !this.canComment() ? '' :
                '<span><a class="reply" href="#">Reply</a></span>') +


                (Cache.app.isAdmin() || Cache.app.isCollaborator() ?
                '<span>' +
                    '<div class="button-dropdown button-dropdown-up">' +
                        '<button type="button"><i class="far fa-cog"></i></button>' +
                        '<div>' +
                            '<ul class="dropdown">' +
                                '<li class="edit">Edit</li>' +
                                '<li class="delete">Delete</li>' +
                            '</ul>' +
                        '</div>' +
                    '</div>' +
                '</span>' : '') +

                (this.model.get('is_public') ? '' :
                '<span><i class="text-warning fad fa-lock-alt tooltip" data-title="Team only"></i></span>') +
            '</div>' +


            (this.is_child ? '' :
            '<div class="replies">' +
                '<a class="show-replies" href="#"' + (_.size(this.views.reply_comments) ? '' : ' style="display:none;"') + '>' +
                    '<span class="text-show">Show</span>' +
                    '<span class="text-hide">Hide</span>' +
                    ' ' +
                    '<span class="count">' + _.size(this.views.reply_comments) + ' ' + (_.size(this.views.reply_comments) === 1 ? 'reply' : 'replies') + '</span>' +
                '</a>' +
                '<div class="region-replies"></div>' +
            '<div>') +

            (this.is_child ? '' :
            '<div class="region-reply-comment-new">' +
                '<div class="region-message-editor"></div>' +
            '</div>') +

        '</div>';

        this.$el.html(content);

        this.renderMsg();
        this.renderReactions();

        if (this.model.get('is_public')) {
            this.$el.removeAttr('data-internal');
        } else {
            this.$el.attr('data-internal', 1);
        }

        _.each(this.views.reply_comments, function(view) {
            view.render().$el.appendTo(this.$el.find('.region-replies'));
        }, this);

        return this;
    }
});

export default Portal_Comment;